import { useEffect, useState } from 'preact/hooks'

/** The image's size in pixels, read once it loads in the browser: the server keeps none. Null until then, or if it never loads. */
export function useImageSize(url: string | null): { width: number; height: number } | null {
    const [size, setSize] = useState<{ width: number; height: number } | null>(null)
    useEffect(() => {
        setSize(null)
        if (!url) return
        let current = true
        const probe = new Image()
        probe.onload = () => { if (current && probe.naturalWidth > 0) setSize({ width: probe.naturalWidth, height: probe.naturalHeight }) }
        probe.src = url
        return () => { current = false }
    }, [url])
    return size
}
